import { render, staticRenderFns } from "./GopChooseLanguage.vue?vue&type=template&id=47b4c1b7&scoped=true"
import script from "./GopChooseLanguage.vue?vue&type=script&lang=js"
export * from "./GopChooseLanguage.vue?vue&type=script&lang=js"
import style0 from "./GopChooseLanguage.vue?vue&type=style&index=0&id=47b4c1b7&prod&lang=scss"
import style1 from "./GopChooseLanguage.vue?vue&type=style&index=1&id=47b4c1b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b4c1b7",
  null
  
)

export default component.exports